if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');         
      if(!this.form) return;
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);   
      
       if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

      
      config.body = formData;
    

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;
          
          // Detectar si viene de crear-tutu
          const urlParams = new URLSearchParams(window.location.search);
          const fromCrearTutu = urlParams.get('from') === 'crear-tutu' || sessionStorage.getItem('from_crear_tutu') === 'true';
          
          // Detectar si estamos en la colección accesorios
          const isAccesorios = window.location.pathname.includes('/collections/accesorios');
          
          // Guardar en sessionStorage si viene de crear-tutu
          if (urlParams.get('from') === 'crear-tutu') {
            sessionStorage.setItem('from_crear_tutu', 'true');
          }
          
          // Si no hay cart drawer/notification
          if (!this.cart) {
            // Si viene de crear-tutu y estamos en accesorios, mostrar modal de accesorio
            if (fromCrearTutu && isAccesorios) {
              setTimeout(() => {
                this.showAccesorioModal();
              }, 300);
              return;
            }
            // Si viene de crear-tutu (pero no en accesorios), mostrar modal de toutou
            if (fromCrearTutu) {
              setTimeout(() => {
                this.showToutouModal();
              }, 300);
              return;
            }
            // Comportamiento normal: redirigir al carrito
            window.location = window.routes.cart_url;
            return;
          }
          
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { 
                this.cart.renderContents(response);
                // Mostrar modal según la colección
                if (fromCrearTutu && isAccesorios) {
                  this.showAccesorioModal();
                } else if (fromCrearTutu) {
                  this.showToutouModal();
                }
              });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
            // Mostrar modal según la colección
            if (fromCrearTutu && isAccesorios) {
              setTimeout(() => {
                this.showAccesorioModal();
              }, 300);
            } else if (fromCrearTutu) {
              setTimeout(() => {
                this.showToutouModal();
              }, 300);
            }
          }
            console.log(Object.fromEntries(formData.entries()));
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');          
        });
    }

    handleErrorMessage(errorMessage = false) {
       if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    showToutouModal() {
      const toutouModal = document.getElementById('ToutouCartModal');
      if (toutouModal) {
        toutouModal.show();
        // Limpiar sessionStorage después de mostrar el modal
        sessionStorage.removeItem('from_crear_tutu');
      }
    }

    showAccesorioModal() {
      const accesorioModal = document.getElementById('AccesorioCartModal');
      if (accesorioModal) {
        accesorioModal.show();
      }
    }
  });
}

$(document).ajaxComplete(function() {
  //CartJS.updateCart();
});
